module.exports = __webpack_public_path__ + "static/media/news-1.d8e3e8d9.pdf";